document.querySelector('.fullscreen-toggle').addEventListener('click', function () {
    toggleFullscreen();
});

document.querySelector('.btn-magnifier').addEventListener('click', function () {
    toggleFullscreen();
});

document.getElementById('btn-exit-fullscreen').addEventListener('click', function () {
    if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
});

document.addEventListener('fullscreenchange', function () {
    if (!isInFullscreen()) {
        document.querySelector('.fullscreen-toggle').src = document.querySelector('.fullscreen-toggle').getAttribute('data-small-src');
        document.querySelector('.fullscreen-toggle').classList.remove('enlarged');
        document.getElementById('btn-exit-fullscreen').classList.add('hide');
        document.querySelector('.plus-stroke').classList.remove('hide');
        document.querySelector('.wrapper').classList.remove('fullscreen');
    }
});

function isInFullscreen() {
    return document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
}

function toggleFullscreen() {
    const fullScreenImage = document.querySelector('.fullscreen-toggle');
    const wrapper = document.querySelector('.wrapper');
    const smallSrc = fullScreenImage.getAttribute('data-small-src');
    const highResSrc = fullScreenImage.getAttribute('data-fullscreen-src');
    if (document.fullscreenElement) {
        document.querySelector('.fullscreen-toggle').classList.toggle('enlarged');
        document.querySelector('.lab-document-img-wrapper').classList.toggle('enlarged');
        document.querySelector('.plus-stroke').classList.toggle('hide');
    }

    if (wrapper.requestFullscreen) {
        wrapper.requestFullscreen();
    } else if (wrapper.webkitRequestFullscreen) {
        wrapper.webkitRequestFullscreen();
    } else if (wrapper.msRequestFullscreen) {
        wrapper.msRequestFullscreen();
    }

    fullScreenImage.src = highResSrc; 
    document.querySelector('.wrapper').classList.add('fullscreen');
    document.getElementById('btn-exit-fullscreen').classList.remove('hide');
}